(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["capim-lovers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function preparePreviewVideo(video) {
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('x5-playsinline', '');
    }

    function playPreviewVideo(video) {
      if (!(video instanceof HTMLVideoElement)) return;

      preparePreviewVideo(video);

      function tryPlay() {
        if (!video.isConnected) return;

        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      }

      if (video.readyState < 2) {
        if (video.dataset.capimLoversPlayQueued !== 'true') {
          video.dataset.capimLoversPlayQueued = 'true';
          video.addEventListener('loadedmetadata', tryPlay, { once: true });
          video.addEventListener('loadeddata', tryPlay, { once: true });
          video.addEventListener('canplay', tryPlay, { once: true });
        }

        video.load();
      }

      tryPlay();
      requestAnimationFrame(tryPlay);
      window.setTimeout(tryPlay, 250);
    }

    function isVideoVisible(video) {
      var rect = video.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth;

      return rect.bottom > 0 && rect.right > 0 && rect.top < viewportHeight && rect.left < viewportWidth;
    }

    function pauseSlideMedia(slide) {
      if (!slide) return;

      slide.querySelectorAll('video').forEach(function (video) {
        video.pause();
      });

      slide.querySelectorAll('iframe[data-capim-lovers-iframe-src]').forEach(function (iframe) {
        iframe.removeAttribute('src');
      });
    }

    function initCapimLovers(scope) {
      var root = scope || document;
      var sections = [];

      if (root.matches && root.matches('[data-capim-lovers-section]')) {
        sections = [root];
      } else if (root.querySelectorAll) {
        sections = Array.prototype.slice.call(root.querySelectorAll('[data-capim-lovers-section]'));
      }

      sections.forEach(function (section) {
        if (section.dataset.capimLoversReady === 'true') return;
        section.dataset.capimLoversReady = 'true';

        var dialog = section.querySelector('[data-capim-lovers-modal]');
        var slides = Array.prototype.slice.call(section.querySelectorAll('[data-capim-lovers-slide]'));
        var previewVideos = Array.prototype.slice.call(section.querySelectorAll('[data-capim-lovers-preview-video]'));
        var activeIndex = 0;

        function playVisiblePreviews() {
          previewVideos.forEach(function (video) {
            if (isVideoVisible(video)) {
              playPreviewVideo(video);
            } else {
              video.pause();
            }
          });
        }

        previewVideos.forEach(function (video) {
          preparePreviewVideo(video);
        });

        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (!(entry.target instanceof HTMLVideoElement)) return;

                if (entry.isIntersecting) {
                  playPreviewVideo(entry.target);
                } else {
                  entry.target.pause();
                }
              });
            },
            { rootMargin: '200px 0px', threshold: 0 }
          );

          previewVideos.forEach(function (video) {
            observer.observe(video);
          });
        } else {
          playVisiblePreviews();
        }

        playVisiblePreviews();
        requestAnimationFrame(playVisiblePreviews);
        window.setTimeout(playVisiblePreviews, 400);
        window.addEventListener('load', playVisiblePreviews, { once: true });
        window.addEventListener('scroll', playVisiblePreviews, { passive: true });
        window.addEventListener('resize', playVisiblePreviews, { passive: true });
        document.addEventListener('touchstart', playVisiblePreviews, { passive: true });
        document.addEventListener('pointerdown', playVisiblePreviews, { passive: true });
        document.addEventListener('visibilitychange', function () {
          if (!document.hidden) playVisiblePreviews();
        });

        if (!dialog || !slides.length) return;

        function setActive(index, playSelected) {
          if (Number.isNaN(index)) index = 0;
          activeIndex = (index + slides.length) % slides.length;

          slides.forEach(function (slide, slideIndex) {
            var isActive = slideIndex === activeIndex;
            slide.classList.toggle('is-active', isActive);
            slide.toggleAttribute('hidden', !isActive);

            if (!isActive) {
              pauseSlideMedia(slide);
              return;
            }

            var iframe = slide.querySelector('iframe[data-capim-lovers-iframe-src]');
            if (iframe && !iframe.getAttribute('src')) {
              iframe.setAttribute('src', iframe.getAttribute('data-capim-lovers-iframe-src'));
            }
          });

          if (playSelected) {
            var activeSlide = slides[activeIndex];
            var activeVideo = activeSlide && activeSlide.querySelector('video');

            if (activeVideo instanceof HTMLVideoElement) {
              activeVideo.play().catch(function () {});
            }
          }
        }

        function openDialog(index) {
          setActive(index, false);

          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }

          setActive(index, true);
        }

        function closeDialog() {
          slides.forEach(pauseSlideMedia);

          if (dialog.open && typeof dialog.close === 'function') {
            dialog.close();
          } else {
            dialog.removeAttribute('open');
          }
        }

        setActive(0, false);

        section.addEventListener('click', function (event) {
          var target = event.target;
          if (!(target instanceof Element)) return;

          var opener = target.closest('[data-capim-lovers-open]');
          if (opener && section.contains(opener)) {
            event.preventDefault();
            openDialog(Number(opener.getAttribute('data-capim-lovers-open')) || 0);
            return;
          }

          if (target.closest('[data-capim-lovers-close]')) {
            event.preventDefault();
            closeDialog();
            return;
          }

          if (target.closest('[data-capim-lovers-prev]')) {
            event.preventDefault();
            setActive(activeIndex - 1, true);
            return;
          }

          if (target.closest('[data-capim-lovers-next]')) {
            event.preventDefault();
            setActive(activeIndex + 1, true);
            return;
          }

          if (target === dialog) {
            closeDialog();
          }
        });

        dialog.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            setActive(activeIndex - 1, true);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            setActive(activeIndex + 1, true);
          }
        });

        dialog.addEventListener('close', function () {
          slides.forEach(pauseSlideMedia);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initCapimLovers(document);
      });
    } else {
      initCapimLovers(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initCapimLovers(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["capim-product-story-bubble"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function hydrateVideo(video) {
      if (!video || video.dataset.capimStoryHydrated === 'true') return;

      var shouldLoad = false;

      video.querySelectorAll('source[data-src]').forEach(function (source) {
        var dataSrc = source.getAttribute('data-src');

        if (dataSrc && source.getAttribute('src') !== dataSrc) {
          source.setAttribute('src', dataSrc);
          shouldLoad = true;
        }
      });

      video.dataset.capimStoryHydrated = 'true';

      if (shouldLoad) {
        video.load();
      }
    }

    function enforceMuted(video) {
      if (!(video instanceof HTMLVideoElement)) return;

      video.muted = true;
      video.defaultMuted = true;
      video.volume = 0;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('x5-playsinline', '');
    }

    function playMuted(video) {
      if (!(video instanceof HTMLVideoElement)) return;

      hydrateVideo(video);
      enforceMuted(video);

      var retryPlay = function () {
        enforceMuted(video);
        var retryPromise = video.play();
        if (retryPromise && typeof retryPromise.catch === 'function') {
          retryPromise.catch(function () {});
        }
      };

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          video.addEventListener('canplay', retryPlay, { once: true });
          video.addEventListener('loadeddata', retryPlay, { once: true });
        });
      }
    }

    function pauseOne(video) {
      if (video instanceof HTMLVideoElement) {
        video.pause();
      }
    }

    function initCapimStoryBubble(root) {
      var scope = root || document;
      var sections = [];

      if (scope.matches && scope.matches('[data-capim-story-bubble]')) {
        sections = [scope];
      } else if (scope.querySelectorAll) {
        sections = Array.prototype.slice.call(scope.querySelectorAll('[data-capim-story-bubble]'));
      }

      sections.forEach(function (section) {
        if (section.dataset.capimStoryReady === 'true') return;
        section.dataset.capimStoryReady = 'true';

        var openButton = section.querySelector('[data-capim-story-open]');
        var dialog = section.querySelector('[data-capim-story-dialog]');
        var overlay = section.querySelector('[data-capim-story-overlay]');
        var closeButton = section.querySelector('[data-capim-story-close]');
        var videos = Array.prototype.slice.call(section.querySelectorAll('[data-capim-story-video]'));
        var previewVideo = section.querySelector('[data-capim-story-preview]');
        var prevButton = section.querySelector('[data-capim-story-prev]');
        var nextButton = section.querySelector('[data-capim-story-next]');
        var currentCounter = section.querySelector('[data-capim-story-current]');
        var lastFocusedElement = null;
        var activeIndex = 0;

        if (!openButton || !dialog || videos.length === 0) return;

        function normalizeIndex(index) {
          index = parseInt(index, 10);

          if (isNaN(index)) return 0;
          if (index < 0) return videos.length - 1;
          if (index >= videos.length) return 0;

          return index;
        }

        function pauseVideos() {
          videos.forEach(pauseOne);
        }

        function setActiveVideo(index, shouldPlay) {
          activeIndex = normalizeIndex(index);

          videos.forEach(function (item, itemIndex) {
            var isActive = itemIndex === activeIndex;

            item.hidden = !isActive;
            item.classList.toggle('capim-product-story-bubble__video--active', isActive);
            item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
            enforceMuted(item);

            if (!isActive) {
              pauseOne(item);
            }
          });

          if (currentCounter) {
            currentCounter.textContent = String(activeIndex + 1);
          }

          if (shouldPlay) {
            window.requestAnimationFrame(function () {
              playMuted(videos[activeIndex]);
            });
          }
        }

        function tryPlayVideo() {
          setActiveVideo(activeIndex, true);
        }

        function closeDialog() {
          if (dialog.open && typeof dialog.close === 'function') {
            dialog.close();
          } else {
            dialog.removeAttribute('open');
            handleDialogClose();
          }
        }

        function handleDocumentKeydown(event) {
          if (event.key === 'Escape') {
            event.preventDefault();
            closeDialog();
          }
        }

        function openDialog() {
          lastFocusedElement = document.activeElement;

          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
            document.addEventListener('keydown', handleDocumentKeydown);
          }

          section.dispatchEvent(
            new CustomEvent('capim:story-bubble-open', {
              bubbles: true,
              detail: {
                sectionId: section.getAttribute('data-capim-story-bubble'),
                source: section.getAttribute('data-capim-story-source'),
              },
            })
          );

          window.requestAnimationFrame(tryPlayVideo);
        }

        function handleDialogClose() {
          pauseVideos();
          document.removeEventListener('keydown', handleDocumentKeydown);

          if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
            lastFocusedElement.focus({ preventScroll: true });
          }
        }

        openButton.addEventListener('click', openDialog);

        if (prevButton) {
          prevButton.addEventListener('click', function () {
            setActiveVideo(activeIndex - 1, true);
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', function () {
            setActiveVideo(activeIndex + 1, true);
          });
        }

        if (previewVideo instanceof HTMLVideoElement) {
          enforceMuted(previewVideo);

          var startPreview = function () {
            if (document.visibilityState === 'hidden') return;

            playMuted(previewVideo);
          };

          var queuePreview = function () {
            if ('requestIdleCallback' in window) {
              window.requestIdleCallback(startPreview, { timeout: 1200 });
            } else {
              window.setTimeout(startPreview, 450);
            }
          };

          previewVideo.addEventListener('volumechange', function () {
            enforceMuted(previewVideo);
          });

          previewVideo.addEventListener('loadedmetadata', startPreview);
          previewVideo.addEventListener('canplay', startPreview);

          document.addEventListener('visibilitychange', function () {
            if (document.visibilityState === 'visible') {
              startPreview();
            }
          });

          if (document.readyState === 'complete') {
            queuePreview();
          } else {
            window.addEventListener('load', queuePreview, { once: true });
          }

          window.setTimeout(startPreview, 350);
          window.setTimeout(startPreview, 1200);
        }

        videos.forEach(function (video, videoIndex) {
          enforceMuted(video);

          video.addEventListener('volumechange', function () {
            enforceMuted(video);
          });

          video.addEventListener('click', function () {
            setActiveVideo(videoIndex, false);

            if (video.paused) {
              playMuted(video);
            } else {
              video.pause();
            }
          });
        });

        setActiveVideo(0, false);

        if (closeButton) {
          closeButton.addEventListener('click', closeDialog);
        }

        dialog.addEventListener('click', function (event) {
          if (event.target === dialog || event.target === overlay) {
            closeDialog();
          }
        });

        dialog.addEventListener('cancel', pauseVideos);
        dialog.addEventListener('close', handleDialogClose);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initCapimStoryBubble(document);
      });
    } else {
      initCapimStoryBubble(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initCapimStoryBubble(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["made-by-dylan"] && !Shopify.designMode) return;
  try {
    
  class DylanShopTheLook extends HTMLElement {
    connectedCallback() {
      this.hotspots = Array.from(this.querySelectorAll('[data-dylan-hotspot]'));
      this.panels = Array.from(this.querySelectorAll('[data-dylan-panel]'));
      this.nextButtons = Array.from(this.querySelectorAll('[data-dylan-next]'));

      this.hotspots.forEach((hotspot) => {
        hotspot.addEventListener('click', () => this.activate(hotspot.dataset.dylanHotspot));
      });

      this.nextButtons.forEach((button) => {
        button.addEventListener('click', () => this.activateNext());
      });
    }

    activate(id) {
      this.hotspots.forEach((hotspot) => {
        const isActive = hotspot.dataset.dylanHotspot === id;
        hotspot.classList.toggle('is-active', isActive);
        hotspot.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.dylanPanel === id;
        panel.classList.toggle('is-active', isActive);
        panel.toggleAttribute('hidden', !isActive);
      });
    }

    activateNext() {
      if (this.hotspots.length < 2) return;

      const activeIndex = this.hotspots.findIndex((hotspot) => hotspot.classList.contains('is-active'));
      const nextIndex = activeIndex === -1 ? 0 : (activeIndex + 1) % this.hotspots.length;
      this.activate(this.hotspots[nextIndex].dataset.dylanHotspot);
      this.hotspots[nextIndex].focus({ preventScroll: true });
    }
  }

  if (!customElements.get('dylan-shop-the-look')) {
    customElements.define('dylan-shop-the-look', DylanShopTheLook);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-premium"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var prev = e.target.closest('[data-slider-prev]');
      var next = e.target.closest('[data-slider-next]');
      if (!prev && !next) return;

      var id = (prev || next).getAttribute(prev ? 'data-slider-prev' : 'data-slider-next');
      var slider = document.getElementById('tp-slider-' + id);
      if (!slider) return;

      var card = slider.querySelector('.tp__card');
      if (!card) return;

      var gap = parseFloat(getComputedStyle(slider).gap) || 0;
      var distance = card.offsetWidth + gap;

      slider.scrollBy({ left: prev ? -distance : distance, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
